// "SELECT" is intentionally NOT a no-lead name: it is the tracker placeholder for a row whose
// company is known but whose person is not yet chosen. Deep Research is allowed there because the
// runner researches the company. "Company not found" / "Person not found" remain blocked.
const NO_LEAD_PROSPECT_NAMES = ["Company not found", "Person not found"];

type ProspectLeadCandidate = {
	id?: number;
	name?: string | null;
};

const normalizeProspectName = (name?: string | null): string => name?.trim().toLowerCase() ?? "";

export const isNoLeadProspectName = (name?: string | null): boolean => {
	const normalizedName = normalizeProspectName(name);

	return NO_LEAD_PROSPECT_NAMES.some(
		(noLeadName) => normalizeProspectName(noLeadName) === normalizedName
	);
};

export const hasValidDeepResearchLead = (prospect?: ProspectLeadCandidate | null): boolean => {
	return !!prospect?.id && !isNoLeadProspectName(prospect.name);
};
